module.exports = __webpack_public_path__ + "img/iconeUser.9fd99d98.svg";